// extracted by mini-css-extract-plugin
export default {"root":"_3y6lO","align-items-center":"_1CW_-","alignItemsCenter":"_1CW_-"};